import { createFileRoute } from '@tanstack/react-router';
import { FacebookFormsAlias } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads')({
  component: FacebookFormsListAliasRoute,
});

function FacebookFormsListAliasRoute() {
  const { workspaceId } = Route.useParams();
  return <FacebookFormsAlias workspaceId={String(workspaceId)} />;
}
